export class Person {
    initalize(row) {
        this.externalID = row[0]
        this.name = row[1]
        this.firstName = this.name.slice(0, this.name.indexOf(" "))
        this.lastName = this.name.slice(this.name.indexOf(" ")+1)
        this.companyPrimaryName = row[2]
        this.companyStripedName = row[3]
        this.skills = row[4]
        this.source = row[5]
        this.resume = row[6]
    }
}